import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

type DealerTireDetailsProps = {
  translation: string;
};

export const SectionHeading: FunctionComponent<DealerTireDetailsProps> = ({
  translation,
}) => {
  const { t } = useTranslation();

  return (
    <h4 className="text-lg font-medium leading-5 mb-2">{t(translation)}</h4>
  );
};
